// Webhook da Cielo (Post de Notificação). As tabelas são escritas pelo
// PaymentHubGo; aqui só se consulta.

/** Desfecho do processamento de uma notificação, espelhando o hub. */
export const CIELO_OUTCOMES = [
  { value: 0, label: 'Recebida' },
  { value: 1, label: 'Processada' },
  { value: 2, label: 'Ignorada' },
  { value: 3, label: 'Erro' },
  { value: 4, label: 'Rejeitada' },
] as const;

/**
 * ChangeType do Post de Notificação. Todos os eventos da Cielo chegam pelo mesmo
 * webhook — é este campo que os distingue.
 */
export const CIELO_CHANGE_TYPES = [
  { value: 1, label: 'Mudança de status da transação' },
  { value: 2, label: 'Recorrência criada' },
  { value: 3, label: 'Status do antifraude' },
  { value: 4, label: 'Status da recorrência' },
  { value: 5, label: 'Cancelamento negado' },
  { value: 6, label: 'Boleto pago a menor' },
  { value: 7, label: 'Chargeback' },
  { value: 8, label: 'Alerta de fraude' },
  { value: 25, label: 'Cancelamento/estorno parcial' },
] as const;

export interface CieloNotificationLogEntry {
  id: number;
  change_type: number | null;
  change_type_label: string;
  payment_id: string | null;
  recurrent_payment_id: string | null;
  raw_body: string | null;
  remote_addr: string | null;
  outcome: number;
  outcome_label: string;
  outcome_message: string | null;
  queried_status: number | null;
  queried_return_code: string | null;
  company_id: number | null;
  received_on: string;
  processed_on: string | null;
}

export interface CardChargebackEntry {
  id: number;
  payment_id: string;
  credit_card_payment_id: number | null;
  company_id: number | null;
  order_id: number | null;
  comercial_proposal_id: number | null;
  customer_name: string | null;
  brand: string | null;
  /** Já em reais — o hub grava em centavos e a API converte. */
  amount: number;
  change_type: number;
  change_type_label: string;
  cielo_status: number | null;
  notified_on: string;
}

export interface CieloWebhookSearchModel {
  page: number;
  pageSize: number;
  dateFrom?: string;
  dateTo?: string;
  changeType?: number;
  outcome?: number;
  paymentId?: string;
}
